"use client"

import imgInit from "../img/portada.jpg"
import imgInitMobile from "../img/portada2.png"
import Header from "./Header"

const Inicio = () => {
  const handleContactClick = (e) => {
    e.preventDefault()
    const phoneNumber = "50256976272"
    const message = "Hola, me interesa obtener más información sobre sus servicios aduaneros."
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`

    window.open(whatsappUrl, "_blank")
  }

  return (
    <section className="section-container">
      <div className="card" id="Inicio">
        <picture className="pict">
          <source media="(max-width: 768px)" srcSet={imgInitMobile || "/placeholder.svg?height=400&width=300"} />
          <img
            src={imgInit || "/placeholder.svg?height=600&width=800&query=desktop hero image"}
            className="img-fluid"
            alt="imagen de portada"
          />
        </picture>
        <div className="container-overlay-data">
          <Header />
          <div className="section-data">
            {/* Sección de contacto */}
            <div className="contact-section">
              <h2 className="contact-title">AGENDA UNA LLAMADA CON UN ASESOR</h2>
              <a href="#" onClick={handleContactClick} className="contact-button-container">
                <div className="contact-button">Contáctanos</div>
                <div className="contact-arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="52"
                    height="52"
                    fill="currentColor"
                    className="bi bi-send-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z"
                      fill="white"
                    />
                  </svg>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Inicio
